import { render, staticRenderFns } from "./TopbarItem.vue?vue&type=template&id=1654d490"
import script from "./TopbarItem.vue?vue&type=script&lang=js"
export * from "./TopbarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports